// 一覧の絞り込みの文字と、行の文字の突き合わせ

// 全角と半角、大文字と小文字の違いを無視して比べられるようにそろえる
function normalizeForSearch(value: string): string {
  return value.normalize('NFKC').toLowerCase();
}

/**
 * 絞り込みの文字を空白で区切った語が、すべて行の項目のどれかに含まれていれば true。
 * 絞り込みの文字が空白だけのときは、すべての行を出すので true
 */
export function matchesSearchText(searchText: string, fields: Array<string | null | undefined>): boolean {
  const words = normalizeForSearch(searchText)
    .split(/\s+/)
    .filter((word) => word !== '');
  if (words.length === 0) {
    return true;
  }
  const normalizedFields = fields
    .filter((field): field is string => typeof field === 'string')
    .map(normalizeForSearch);
  return words.every((word) => normalizedFields.some((field) => field.includes(word)));
}
